import { render, staticRenderFns } from "./OwnerConfirm.vue?vue&type=template&id=77d76c8e&"
import script from "./OwnerConfirm.vue?vue&type=script&lang=js&"
export * from "./OwnerConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports